/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_FullInputs */

const en_us2_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This club is full.`)
};

const pt_br2_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este clube está cheio.`)
};

const es_419_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este club está lleno.`)
};

const pt_pt2_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este clube está cheio.`)
};

const fr_fr2_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce club est complet.`)
};

const de_de2_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Club ist voll.`)
};

const it_it2_clubs_join_full = /** @type {(inputs: Clubs_Join_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo club è pieno.`)
};

/**
* | output |
* | --- |
* | "This club is full." |
*
* @param {Clubs_Join_FullInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_full = /** @type {((inputs?: Clubs_Join_FullInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_FullInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_full(inputs)
	if (locale === "es-419") return es_419_clubs_join_full(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_full(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_full(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_full(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_full(inputs)
	return en_us2_clubs_join_full(inputs)
});
export { clubs_join_full as "clubs.join_full" }